module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "delete-bool-button"
    }
  }, [(_vm.disable) ? [_vm._m(0)] : [_c('div', {
    staticClass: "cursor-pointer",
    class: [_vm.deleteIconBool ? 'del-checked' : 'del-unchecked'],
    on: {
      "click": function($event) {
        _vm.toggleDelete(!_vm.deleteIconBool)
      }
    }
  }, [_c('i', {
    staticClass: "icon-delete-desc",
    class: 'fa fa-' + [_vm.deleteIconBool ? 'trash' : 'trash-o']
  })])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "del-disable"
  }, [_c('i', {
    staticClass: "fa fa-trash text-gray icon-delete-desc"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-680c6a4b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsTableTemplate/deleteButton.vue
// module id = 3829
// module chunks = 1